import { BasicTextField } from '../BasicTextField/BasicTextField'

import type { FormFieldWrapper } from '@ngb-frontend/shared/types'

export const StreetNameField: React.FC<FormFieldWrapper> = ({
  name,
  ...props
}) => (
  <BasicTextField
    {...props}
    field="street-name"
    labelKey="fields.streetName.label"
    name={name ?? 'street'}
  />
)
